import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

interface BodyContent {
  amount: string
  icon: React.ReactNode
  primaryText: string
  secondaryText: string
}

interface TransactionCardProps {
  bodyContent: BodyContent[]
  footerLeftText?: string
  footerRightText?: string
  headerText?: string
}

const TransactionCard = ({
  bodyContent,
  footerLeftText,
  footerRightText,
  headerText,
}: TransactionCardProps) => {
  return (
    <Stack
      sx={{
        outlineColor: 'divider',
        borderRadius: '4px',
        outlineStyle: 'solid',
        outlineWidth: '1px',
        maxWidth: 288,
        minWidth: 224,
      }}
    >
      {/* Header */}
      {headerText && (
        <Stack
          sx={{
            bgcolor: 'background.default',
            borderBottom: '1px solid',
            borderBottomColor: 'divider',
            height: 40,
            justifyContent: 'center',
            px: 16,
            py: 2,
          }}
        >
          <Text sx={{ fontWeight: 700 }} variant="caption">
            {headerText}
          </Text>
        </Stack>
      )}

      {/* Body */}
      {bodyContent.map(({ amount, icon, primaryText, secondaryText }, index) => (
        <Stack
          key={index}
          sx={{
            ...((bodyContent.length - 1 !== index || !!(footerLeftText && footerRightText)) && {
              borderBottom: '1px solid',
              borderBottomColor: 'divider',
            }),
            flexDirection: 'row',
            gap: 16,
            px: 16,
            py: 14,
          }}
        >
          <Stack sx={{ alignItems: 'center', flex: 1, flexDirection: 'row', gap: 12, minWidth: 0 }}>
            {icon}
            <Stack sx={{ minWidth: 0 }}>
              <Text bold={true} variant="body1">
                {primaryText}
              </Text>
              <Text variant="caption">{secondaryText}</Text>
            </Stack>
          </Stack>
          <Text bold={true} variant="body1">
            {amount}
          </Text>
        </Stack>
      ))}

      {/* Footer */}
      {footerLeftText && footerRightText && (
        <Stack
          sx={{
            alignItems: 'center',
            bgcolor: 'background.default',
            flexDirection: 'row',
            gap: 16,
            height: 40,
            justifyContent: 'space-between',
            px: 16,
            py: 2,
          }}
        >
          <Text color="text.secondary" variant="caption">
            {footerLeftText}
          </Text>
          <Text bold={true} variant="body2">
            {footerRightText}
          </Text>
        </Stack>
      )}
    </Stack>
  )
}

export default TransactionCard
